import { createSelector } from '@ngrx/store';
import { IAppState } from '../state/app.state';
import { IAlertState } from '../state/alert.state';

const selectAlert = (state: IAppState) => state.alert;

export const alertSelector = createSelector(
    selectAlert,
    (state: IAlertState) => state,
);
